import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  max-width: 480px;
  border-radius: 20px;
  background: ${theme.backgrounds.backgroundThree};
  padding: 24px;
  margin-top: 24px;
`

export const form = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
